import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment.local';
import { version } from '../environments/version';
import { SessionRefreshService } from './order/services/internal/session-refresh/session-refresh.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  public title = 'credenciamento';

  constructor(private sessionRefreshService: SessionRefreshService) {}

  ngOnInit() {
    this.sessionRefreshService.start();
    console.log('Application profile:', environment.profile);
    console.log('Last build date:', version.timeStamp);
    console.log('Version:', version.version);
  }
}
